import { closeModalGlobal} from '../../../js/components/modal';

const init = () => {
  const globalModalWrapper = document.createElement('div');
  globalModalWrapper.classList.add('global-modal-wrapper');
  globalModalWrapper.setAttribute('id', 'global-modal');

  globalModalWrapper.innerHTML = `
    <div id="modal-content" class="modal-content">
      <svg id="modal-close-btn" class="close-button"><use xlink:href="#plus-thin"></use></svg>
    </div>
  `;
  document.body.appendChild(globalModalWrapper);

  const modalContent = globalModalWrapper.querySelector('#modal-content');
  const close_btn = globalModalWrapper.querySelector('#modal-close-btn');
  if (close_btn) {
    close_btn.addEventListener('click', closeModalGlobal);
  }
  if (modalContent && globalModalWrapper) {
    modalContent.addEventListener('click', (e) => {
      e.stopPropagation();
    })
  }
}

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/templates/components/global-modal/global-modal.js